import "./styles.scss"

const Checkboxes = () => {
    return <div className="inputs-checkboxes-container">Checkboxes</div>
}

export default Checkboxes